import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.scss'],
})
export class ProgressCircleComponent implements OnChanges {
  @Input() percentage: number | null = null;

  isLoading = true;
  displayPercent: number = 0;

  ngOnChanges(): void {
    if (this.percentage === null || this.percentage === undefined || isNaN(Number(this.percentage))) {
      this.displayPercent = 0;
      this.isLoading = true;
      return;
    }

    this.displayPercent = Math.round(Number(this.percentage));
    this.isLoading = false;
  }

  get circumference(): number {
    return 2 * Math.PI * 34;
  }

  get offset(): number {
    return this.circumference - (this.displayPercent / 100) * this.circumference;
  }
}
